

import  { useState} from "react";
import AddProject from "./AddProject";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Label } from "@/components/atoms/texts/label";
import { Button } from "@/components/molecules/buttons/button";
import AddIcon from "@mui/icons-material/Add";
import PrintProject from "./PrintProject";
import { motion } from "framer-motion";
import { item } from "@/utils/animationConst";
import PrintErrorMessage from '@/components/organisms/feedback/PrintErrorMessage';

export default function Project({
  hideAllOverview,
  showComponent,
  projects,

  user,
  setIsDoingAction,
}) {
  const [showForm, setShowForm] = useState(false);

  const [editingProject, setEditingProject] = useState(false);
  const [fomrIsValid, setFormIsValid] = useState(false);
  const [serverresponseIsError, setServerResponseIserror] = useState(false);
  const [userTapping, setUserTapping] = useState(false);
   const [errors, setErrors] = useState(null);
  
  const hider = () => {
    hideAllOverview(false);
    showComponent(false);
  };
  const handleAdd = () => {
    setShowForm(true);
    setFormIsValid(false)
}
  return (
    <motion.div variants={item}>
      {serverresponseIsError && <PrintErrorMessage error={errors} />}
      <div className="flex items-center gap-fourthDegree w-full">
        <Button
          showLeftIcon={true}
          leftIcon={
            <ArrowBackIcon className="cursor-pointer" onClick={hider} />
          }
          showText={false}
          style="ghost"
          onClick={hider}
        />
        <div className="basis-3/4">
          <Label
            message="consultants.statement.prospectConsultantPanel.projects"
            size="h3"
            fontWeight="bold"
          />
        </div>

        <Button
          showLeftIcon={true}
          leftIcon={<AddIcon fontSize="small" />}
          showText={true}
          text="global.actions.add"
          sizePadding="default" // Utilisez "small" pour un padding plus petit
          style="ghost"
          className="font-bold basis-1/4 "
          onClick={handleAdd} // Options: "fill", "outline", "ghost", "dressedGhost"
        />
      </div>
      <div className=" flex flex-col gap-secondDegree">
        {showForm && (
          <AddProject
            showForm={showForm}
            setShowForm={setShowForm}
            editingProject={false}
            setEditingProject={setEditingProject}
            user={user}
            setIsDoingAction={setIsDoingAction}
            setFormIsValid={setFormIsValid}
            setServerResponseIserror={setServerResponseIserror}
            setUserTapping={setUserTapping}
            setErrors={setErrors}
          />
        )}
        <div className=" flex flex-col gap-firstDegree">
          {projects.map((project) => {
            return (
              <PrintProject
                key={project.uuid}
                project={project}
                setEditingProject={setEditingProject}
                editingProject={editingProject}
                user={user}
                setIsDoingAction={setIsDoingAction}
                setFormIsValid={setFormIsValid}
                setServerResponseIserror={setServerResponseIserror}
                setUserTapping={setUserTapping}
                setErrors={setErrors}
              />
            );
          })}
        </div>
      </div>
    </motion.div>
  );
}